import { ReactElement } from 'react';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectProps } from '@mui/material/Select';
import kebabCase from 'lodash/kebabCase';
import { useTranslation } from 'react-i18next';

type SelectComponentProps = SelectProps & {
  label: string;
  errorText?: string;
};

const SelectComponent = ({ label, errorText, children, required, ...muiSelectProps }: SelectComponentProps): ReactElement => {
  const { t } = useTranslation();

  return (
    <FormControl fullWidth error={!!errorText}>
      <InputLabel id={`${kebabCase(label)}-label`}>{label}</InputLabel>
      <Select labelId={`${kebabCase(label)}-label`} label={label} {...muiSelectProps}>
        {children}
      </Select>
      {required && !errorText && <FormHelperText>{`*${t('common.required-helper-text')}`}</FormHelperText>}
      {errorText && <FormHelperText>{errorText}</FormHelperText>}
    </FormControl>
  );
};

export default SelectComponent;
